import { deepCopyObject, getIdByRelationshipType } from "../../utils/helpers";

import constants from "../../assets/constants";
import { differenceInYears } from "date-fns";

export const hydrateNewAssessment = (assessmentODM, subjectODM) => {
  if (assessmentODM != null && subjectODM != null && assessmentODM.omniData.startDate == null) {
    //make a local copy
    let newAssessmentODM = deepCopyObject(assessmentODM);
    let now = new Date();

    let subjectIsMyself =
      getIdByRelationshipType(
        subjectODM.omniRelationships.relatedData,
        constants.omniRelationshipTypes.proxyPatient
      ) ||
      (subjectODM.omniData.hasOwnProperty("isProxyPatient") && subjectODM.omniData.isProxyPatient);

    //hydrate each questions
    newAssessmentODM.omniData.questions.forEach((question, index) => {
      try {
        newAssessmentODM.omniData.questions[index].text = varHydration(
          question.text,
          subjectODM,
          subjectIsMyself
        );
        newAssessmentODM.omniData.questions[index].subText = varHydration(
          question.subText,
          subjectODM,
          subjectIsMyself
        );
        if (
          newAssessmentODM.omniData.questions[index].shortTitle === "subjectDateOfBirth" &&
          subjectODM.omniData.birthdate
        ) {
          newAssessmentODM.omniData.questions[index].helpText = varHydration(
            question.helpText,
            subjectODM,
            subjectIsMyself
          );
        } else {
          newAssessmentODM.omniData.questions[index].helpText = "";
        }
        newAssessmentODM.omniData.questions[index].instructions = varHydration(
          question.instructions,
          subjectODM,
          subjectIsMyself
        );

        // We need to update the questions that we already have the answers to
        //we should do this based on the scraping util eventually
        //birthdate
        if (
          newAssessmentODM.omniData.questions[index].shortTitle === "subjectDateOfBirth" &&
          subjectODM.omniData.birthdate
        ) {
          newAssessmentODM.omniData.questions[index].answerValue = [subjectODM.omniData.birthdate];
          newAssessmentODM.omniData.questions[index].answerDate = now.toISOString();
        }
        //zip
        if (
          (newAssessmentODM.omniData.questions[index].displayType === "zipCode" ||
            newAssessmentODM.omniData.questions[index].omniID === "ARPSIE33") &&
          subjectODM.omniData.address &&
          subjectODM.omniData.address.postalCode
        ) {
          newAssessmentODM.omniData.questions[index].answerValue = [
            subjectODM.omniData.address.postalCode,
          ];
          newAssessmentODM.omniData.questions[index].answerDate = now.toISOString();
        }
        //race
        if (
          (newAssessmentODM.omniData.questions[index].omniID === "ARPSIE31" ||
            newAssessmentODM.omniData.questions[index].shortTitle === "subjectRace") &&
          subjectODM.omniData.race
        ) {
          newAssessmentODM.omniData.questions[index].answerValue = [subjectODM.omniData.race];
          newAssessmentODM.omniData.questions[index].answerDate = now.toISOString();
        }
        //ethnic
        if (
          (newAssessmentODM.omniData.questions[index].omniID === "ARPSIE30" ||
            newAssessmentODM.omniData.questions[index].shortTitle === "subjectEthnicity") &&
          subjectODM.omniData.ethnicity
        ) {
          newAssessmentODM.omniData.questions[index].answerValue = [subjectODM.omniData.ethnicity];
          newAssessmentODM.omniData.questions[index].answerDate = now.toISOString();
        }
      } catch (error) {
        console.log("Error during hydration: " + error);
      }
    });

    //Flag this as Started
    if (newAssessmentODM.hasOwnProperty("omniSchedule")) {
      newAssessmentODM.omniSchedule.scheduleStartDate = now.toISOString();
    }

    newAssessmentODM.omniData.startDate = now.toISOString();
    return newAssessmentODM;
  }
};

const varHydration = (text, subjectODM, subjectIsMyself) => {
  let myHydratedText = text;

  let subjectVars = {
    name: subjectIsMyself ? "you" : subjectODM.omniData.givenName,
    possessiveName: subjectIsMyself ? "your" : `${subjectODM.omniData.givenName}'s`,
    subjectPronoun: subjectIsMyself
      ? "you"
      : subjectODM.omniData.gender !== undefined && subjectODM.omniData.gender === "female"
      ? "she"
      : subjectODM.omniData.gender !== undefined && subjectODM.omniData.gender === "male"
      ? "he"
      : "they",
    possesivePronoun: subjectIsMyself
      ? "your"
      : subjectODM.omniData.gender !== undefined && subjectODM.omniData.gender === "female"
      ? "her"
      : subjectODM.omniData.gender !== undefined && subjectODM.omniData.gender === "male"
      ? "his"
      : "their",
    possessiveVerb: subjectIsMyself ? "have" : "has",
    emphasisVerb: subjectIsMyself ? "do" : "does",
    presentLinkingVerb: subjectIsMyself ? "are" : "is",
    pastLinkingVerb: subjectIsMyself ? "were" : "was",
  };

  myHydratedText = myHydratedText.replaceAll("{his/her/their/your}", subjectVars.possesivePronoun);

  myHydratedText = myHydratedText.replaceAll("{he/she/they/you}", subjectVars.subjectPronoun);
  myHydratedText = myHydratedText.replaceAll("{is/are}", subjectVars.presentLinkingVerb);
  myHydratedText = myHydratedText.replaceAll("{has/have}", subjectVars.possessiveVerb);
  myHydratedText = myHydratedText.replaceAll("{does/do}", subjectVars.emphasisVerb);
  myHydratedText = myHydratedText.replaceAll("{was/were}", subjectVars.pastLinkingVerb);
  myHydratedText = myHydratedText.replaceAll("{subject name/you}", subjectVars.name);
  myHydratedText = myHydratedText.replaceAll("{subject name's/your}", subjectVars.possessiveName);

  myHydratedText = myHydratedText.replaceAll(
    "{age}",
    differenceInYears(new Date(), new Date(subjectODM.omniData.birthdate))
  );

  myHydratedText = myHydratedText.charAt(0).toUpperCase() + myHydratedText.slice(1);

  return myHydratedText;
};
